var Model = require('../Model');

var User = Object.create(Model)

User.name = 'User';
User['@class'] =  'User'
User.url = 'user'

User.fields = {
  isSuperuser: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isReportAdmin: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isDeveloper: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isApiUser: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  isCalibrationSuperuser: {
    type: 'select',
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  }
};

module.exports = User;
